import { DateTimeSelection } from 'accounts/components/multiselect-date-time-range-picker/multiselect-date-time-range-picker';

interface InspectionScheduleData {
  selectedSelections: DateTimeSelection[];
  selectedDate: string | null;
  specificRequests: string;
}

const STORAGE_KEY = 'inspection-schedule-data';

const getData = (): InspectionScheduleData => {
  try {
    const stored = sessionStorage.getItem(STORAGE_KEY);
    if (stored) {
      return JSON.parse(stored);
    }
  } catch (error) {
    console.warn(
      'Failed to parse inspection schedule data from sessionStorage:',
      error,
    );
  }

  return {
    selectedSelections: [],
    selectedDate: null,
    specificRequests: '',
  };
};

const setData = (data: InspectionScheduleData): void => {
  try {
    sessionStorage.setItem(STORAGE_KEY, JSON.stringify(data));
  } catch (error) {
    console.warn(
      'Failed to save inspection schedule data to sessionStorage:',
      error,
    );
  }
};

export const getSelectedSelections = (): DateTimeSelection[] => {
  return getData().selectedSelections;
};

export const setSelectedSelections = (
  selections: DateTimeSelection[],
): void => {
  const data = getData();
  data.selectedSelections = selections;
  setData(data);
};

export const getSelectedDate = (): string | null => {
  return getData().selectedDate;
};

export const setSelectedDate = (date: string | null): void => {
  const data = getData();
  data.selectedDate = date;
  setData(data);
};

export const getSpecificRequests = (): string => {
  return getData().specificRequests;
};

export const setSpecificRequests = (requests: string): void => {
  const data = getData();
  data.specificRequests = requests;
  setData(data);
};

export const updateInspectionData = (
  updates: Partial<InspectionScheduleData>,
): void => {
  const data = getData();
  Object.assign(data, updates);
  setData(data);
};

export const clearInspectionData = (): void => {
  try {
    sessionStorage.removeItem(STORAGE_KEY);
  } catch (error) {
    console.warn(
      'Failed to clear inspection schedule data from sessionStorage:',
      error,
    );
  }
};

export const getAllInspectionData = (): InspectionScheduleData => {
  return getData();
};
